module.exports = __webpack_public_path__ + "images/home/bg-934d8dd9f44894dbaf78383d3a58d873.jpg";